import { useAddExtractedTextMutation } from '@carboncopyco/data';
import type { IRecording, TextExtractionData } from '@carboncopyco/types';
import { useState } from 'react';
import { TextExtractionEventsEnum } from '../../../shared/enums/TextExtractionEventsEnum';
import useElectronListener from '../../hooks/useElectronListener';
import { useDownloadExtractedText } from './useDownloadExtractedText';
import type { IGlobalTab } from '@carboncopyco/types/desktop';

export const useTextExtraction = ({
  tabId,
  recording,
}: { tabId: IGlobalTab['id']; recording?: IRecording }) => {
  const [isTextExtractionStarted, setIsTextExtractionStarted] = useState(false);

  const [addExtractedText] = useAddExtractedTextMutation();
  const { downloadExtractedText, isCSVEmpty } = useDownloadExtractedText({
    organizationId: recording?.organizationId,
    cloneRevisionId: recording?.revisionId,
    cloneId: recording?.id,
  });

  useElectronListener(
    TextExtractionEventsEnum.MAIN_TO_RENDERER_SEND_EXTRACTED_TEXT,
    (data: TextExtractionData) => {
      if (data.extractedContent?.length) {
        if (!recording) {
          return;
        }
        addExtractedText({
          organizationId: recording.organizationId,
          entityId: String(recording.id),
          entityType: 'record',
          revisionId: String(recording.revisionId),
          extractedContent: data.extractedContent,
        });
      }
    }
  );

  const toggleTextExtraction = (isSelected: boolean) => {
    setIsTextExtractionStarted(isSelected);
    window.dsDesktop?.textExtraction?.toggleSelected(tabId, isSelected);
  };

  const startTextExtraction = () => {
    toggleTextExtraction(true);
  };

  const stopTextExtraction = () => {
    toggleTextExtraction(false);
  };

  return {
    isCSVEmpty,
    isTextExtractionStarted,
    startTextExtraction,
    stopTextExtraction,
    downloadExtractedText,
  };
};
